/******/ (() => { // webpackBootstrap
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function watchPredictiveForChange(targetClassName) {
  // Select the target node
  var targetNode = document.querySelector('.' + targetClassName);

  // Check if the target node exists
  if (targetNode) {
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(function (mutationsList, observer) {
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (!targetNode.classList.contains('hidden')) {
              document.body.classList.add('openPredictive');
            } else {
              document.body.classList.remove('openPredictive');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });

    // Configuration of the observer
    var config = {
      attributes: true
    };

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  } else {
    console.error('Target node not found.');
  }
}
watchPredictiveForChange('site-search-field-container');

// Toggle Filters

var filters = document.querySelector('.js-filters-container');
var openFilters = document.querySelectorAll('.js-open-filters');
var closeFilters = document.querySelectorAll('.js-close-filters');
var filtersBg = document.querySelector('.js-filters-bg');
var body = document.querySelector('body');
openFilters.forEach(function (openFilter) {
  openFilter.addEventListener('click', function () {
    filtersBg.classList.remove('hidden');
    filters.style.height = '85vh';
    body.classList.add('overflow-hidden');
  });
});
closeFilters.forEach(function (closeFilter) {
  closeFilter.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent the default anchor behavior
    filters.style.height = '0';
    filters.style.overflow = 'hidden';
    filtersBg.classList.add('hidden');
    body.classList.remove('overflow-hidden');
  });
});
/******/ })()
;